import React, { FunctionComponent } from 'react'
import styles from './UsersList.module.sass'
import clsx from 'clsx'

export const UserListIcon: FunctionComponent<{ className?: string, onClick?: () => void }> = props => {
    return <div
        className={clsx(props.className, styles.icon)}
        onClick={props.onClick}
    >
        <div className={styles.text}>{props.children}</div>
    </div>
}